// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1etHT","inputDescription":"styles_inputDescription__1rn5y"};